/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:54:38
 * @LastEditTime: 2020-04-13 14:13:39
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import EmojiDialog from './emojiDialog';

export default EmojiDialog;
